import { useParams, Link } from 'react-router-dom';
import { useSEO } from '@/hooks/useSEO';
import { articleDetails } from '@/mocks/articleData';
import { categories, categoryArticles } from '@/mocks/categoryData';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const readerComments = [
  {
    id: 'rc-1',
    name: '吃瓜十年',
    role: '忠实读者',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20casual%20person%2C%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20soft%20lighting&width=100&height=100&seq=rc-avatar-01&orientation=squarish',
    quote: '这篇爆料太劲爆了，证据链完整，不像其他号只放照片不放实锤。支持51爆料，永远是你们忠实读者！',
    type: 'text',
  },
  {
    id: 'rc-2',
    name: '娱乐圈小透明',
    role: '自媒体博主',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20creative%20person%2C%20warm%20taupe%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20artistic%20vibe&width=100&height=100&seq=rc-avatar-02&orientation=squarish',
    quote: '作为同行，不得不说51爆料的信息源确实厉害。很多我们在外面听不到的内幕，这里能第一时间拿到。继续加油！',
    type: 'text',
  },
  {
    id: 'rc-3',
    name: '理性围观群众',
    role: '用户',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20portrait%20of%20thoughtful%20person%20in%20warm%20dramatic%20lighting%2C%20dark%20background%20with%20amber%20highlights%2C%20editorial%20fashion%20photography%2C%20mysterious%20mood%2C%20rich%20burgundy%20and%20gold%20tones%2C%20cinematic%20quality&width=800&height=600&seq=rc-photo-03&orientation=landscape',
    quote: '',
    type: 'photo',
  },
  {
    id: 'rc-4',
    name: '资深瓜农',
    role: '订阅用户 2年',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20portrait%20with%20warm%20dramatic%20side%20lighting%2C%20half%20face%20in%20shadow%2C%20deep%20amber%20and%20burgundy%20contrast%2C%20cinematic%20composition%2C%20editorial%20style%2C%20investigative%20journalism%20vibe%2C%20rich%20texture&width=1400&height=900&seq=rc-photo-04&orientation=landscape',
    quote: '从大学开始关注51爆料，到现在工作三年了依然每天刷。这里的内容真实、有深度，不是那种标题党。希望越做越好！这篇分析得很透彻，特别是关于平台处理那部分，很多细节我在其他平台都没看到。',
    type: 'photoLarge',
  },
  {
    id: 'rc-5',
    name: '吃瓜研究生',
    role: '论坛版主',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20intellectual%20person%2C%20warm%20cream%20and%20taupe%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20academic%20vibe&width=100&height=100&seq=rc-avatar-05&orientation=squarish',
    quote: '每次看51爆料的文章都像看侦探小说一样过瘾，而且有理有据，不是空穴来风。这篇爆料的转账记录截图太震撼了。',
    type: 'textSmall',
  },
  {
    id: 'rc-6',
    name: '路人甲乙',
    role: '产品经理',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20professional%20person%2C%20warm%20beige%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20thoughtful%20expression&width=100&height=100&seq=rc-avatar-06&orientation=squarish',
    quote: '全网最敢说的爆料平台，不站队、不洗白，事实就是事实。这点在现在的网络环境里太难得了。希望继续保持这种态度。',
    type: 'textSmall',
  },
];

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? articleDetails[slug] : undefined;

  useSEO({
    title: article
      ? `${article.title} | 51爆料 - ${article.category}独家速报`
      : '文章 | 51爆料',
    description: article
      ? `${article.summary} 51爆料${article.category}栏目独家深度追踪。`
      : '51爆料文章详情页',
    keywords: article
      ? `51爆料,${article.category},${article.title},网红翻车,明星黑料,吃瓜爆料`
      : '51爆料,吃瓜爆料',
    url: article
      ? `https://www.51baoliao.com/article/${article.slug}`
      : 'https://www.51baoliao.com/article',
    type: 'article',
    image: article?.image,
    publishedTime: article?.date,
    author: article?.author,
    section: article?.category,
    breadcrumbs: [
      { name: '首页', url: 'https://www.51baoliao.com/' },
      ...(article
        ? [
            { name: article.category, url: `https://www.51baoliao.com/category/${article.categorySlug}` },
            { name: article.title, url: `https://www.51baoliao.com/article/${article.slug}` },
          ]
        : []),
    ],
  });

  if (!article) {
    return (
      <>
        <Navbar />
        <div className="pt-24 text-center text-foreground-400 py-40">
          <i className="ri-error-warning-line text-4xl mb-4"></i>
          <h1 className="text-2xl font-bold text-foreground-950 mb-2">文章未找到</h1>
          <Link to="/" className="text-primary-500 hover:text-primary-600">返回首页</Link>
        </div>
        <Footer />
      </>
    );
  }

  const category = categories[article.categorySlug];

  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full min-h-[400px] md:min-h-[480px] flex items-end overflow-hidden bg-background-100 pt-24">
          <div className="absolute inset-0">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover object-top"
              title={article.title}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-black/30"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 pb-8 md:pb-12">
            <div className="flex flex-col lg:flex-row items-start lg:items-end gap-6 lg:gap-16">
              <div className="flex-1">
                <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-black text-background-50 leading-tight tracking-tight">
                  {article.title}
                </h1>
              </div>
              <div className="flex-1 lg:pb-1">
                <p className="text-background-50/70 text-sm md:text-base leading-relaxed mb-3 max-w-md">
                  {article.summary}
                </p>
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-background-50/60 text-xs">作者：{article.author}</span>
                  <span className="text-background-50/30 text-xs">·</span>
                  <span className="text-background-50/60 text-xs">{article.date}</span>
                </div>
                <Link
                  to={`/category/${article.categorySlug}`}
                  className="group inline-flex items-center gap-2 text-accent-500 font-semibold text-sm hover:text-accent-400 transition-colors cursor-pointer"
                >
                  关注{article.category}
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="w-full bg-background-50 border-b border-background-200/70 px-4 md:px-6 py-3">
          <nav aria-label="面包屑导航">
            <ol className="flex items-center gap-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-500 hover:text-foreground-700 transition-colors">首页</Link>
              </li>
              <li className="text-foreground-300"><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li>
                <Link to={`/category/${article.categorySlug}`} className="text-foreground-500 hover:text-foreground-700 transition-colors">
                  {article.category}
                </Link>
              </li>
              <li className="text-foreground-300"><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li className="text-primary-600 font-medium" aria-current="page">
                {article.title}
              </li>
            </ol>
          </nav>
        </div>

        {/* Article Content + Stats */}
        <section className="w-full bg-background-100 py-10 md:py-14">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto mb-10 md:mb-14">
              <div className="mb-6">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full">
                  <i className="ri-fire-line text-xs"></i>
                  深度追踪
                </span>
              </div>
              <div
                className="article-content text-foreground-700 text-sm md:text-base leading-relaxed"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />
            </div>

            <div className="max-w-3xl mx-auto mb-10 md:mb-14">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20portrait%20of%20professional%20journalist%2C%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20background%2C%20modern%20aesthetic%2C%20confident%20expression&width=100&height=100&seq=author-avatar&orientation=squarish"
                    alt={article.author}
                    className="w-full h-full object-cover"
                    title={article.author}
                  />
                </div>
                <div>
                  <p className="text-foreground-950 font-semibold text-sm">{article.author}</p>
                  <p className="text-foreground-400 text-xs">51爆料特约记者</p>
                </div>
              </div>
              <p className="text-foreground-500 text-sm">
                文章观点仅代表作者本人，不代表51爆料立场。
              </p>
            </div>

            {/* Stats */}
            <div className="max-w-3xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
                <div>
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-3xl md:text-4xl font-black text-foreground-950">{article.stats.reads}</span>
                  </div>
                  <p className="text-foreground-400 text-sm mt-1">阅读量</p>
                </div>
                <div>
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-3xl md:text-4xl font-black text-foreground-950">{article.stats.comments}</span>
                  </div>
                  <p className="text-foreground-400 text-sm mt-1">讨论量</p>
                </div>
                <div>
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-3xl md:text-4xl font-black text-foreground-950">{article.stats.likes}</span>
                  </div>
                  <p className="text-foreground-400 text-sm mt-1">点赞率</p>
                </div>
                <div>
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-3xl md:text-4xl font-black text-foreground-950">{article.stats.trackDays}</span>
                    <span className="text-foreground-400 text-lg">天</span>
                  </div>
                  <p className="text-foreground-400 text-sm mt-1">追踪时长</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Related Articles */}
        {category && (
          <section className="w-full bg-background-50 py-10 md:py-14">
            <div className="w-full px-4 md:px-6">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6">
                更多{article.category}
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {categoryArticles[article.categorySlug]?.slice(0, 3).map((item) => (
                  <Link
                    key={item.slug}
                    to={`/article/${item.slug}`}
                    className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer"
                  >
                    <div className="w-full aspect-[16/10] overflow-hidden">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                        title={item.title}
                      />
                    </div>
                    <div className="p-4 md:p-5">
                      <h4 className="text-foreground-950 text-sm md:text-base font-bold leading-snug mb-1">
                        {item.title}
                      </h4>
                      <p className="text-foreground-400 text-xs">{item.date}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Reader Comments */}
        <section className="w-full bg-secondary-50/50 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 mb-4">
                <span className="w-3 h-3 bg-accent-500 rounded-full"></span>
                <span className="text-accent-700 text-xs font-semibold uppercase tracking-wider">瓜友锐评</span>
              </div>
              <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950">
                千条热评
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {readerComments.slice(0, 3).map((item) => {
                if (item.type === 'photo') {
                  return (
                    <div key={item.id} className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                      <img
                        src={item.avatar}
                        alt={item.name}
                        className="w-full h-full object-cover"
                        title={item.name}
                      />
                      <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/60 to-transparent">
                        <p className="text-background-50 font-semibold text-sm">{item.name}</p>
                        <p className="text-background-50/60 text-xs">{item.role}</p>
                      </div>
                    </div>
                  );
                }

                return (
                  <div key={item.id} className="bg-background-50 rounded-2xl p-5 md:p-6 border border-secondary-200/60">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                        <img
                          src={item.avatar}
                          alt={item.name}
                          className="w-full h-full object-cover"
                          title={item.name}
                        />
                      </div>
                      <div>
                        <p className="text-foreground-950 font-semibold text-sm">{item.name}</p>
                        <p className="text-foreground-400 text-xs">{item.role}</p>
                      </div>
                    </div>
                    <div className="text-accent-500 mb-3">
                      <i className="ri-double-quotes-l text-2xl"></i>
                    </div>
                    <p className="text-foreground-700 text-sm leading-relaxed">
                      {item.quote}
                    </p>
                  </div>
                );
              })}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
              {readerComments.slice(3, 6).map((item) => {
                if (item.type === 'photoLarge') {
                  return (
                    <div key={item.id} className="md:col-span-1 relative rounded-2xl overflow-hidden aspect-[16/9] md:aspect-auto">
                      <img
                        src={item.avatar}
                        alt={item.name}
                        className="w-full h-full object-cover"
                        title={item.name}
                      />
                      <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 bg-gradient-to-t from-primary-900/80 to-transparent">
                        <p className="text-background-50 font-semibold text-sm mb-1">{item.name}</p>
                        <p className="text-background-50/60 text-xs mb-2">{item.role}</p>
                        <p className="text-background-50/80 text-xs leading-relaxed line-clamp-3">
                          {item.quote}
                        </p>
                      </div>
                    </div>
                  );
                }

                return (
                  <div key={item.id} className="bg-background-50 rounded-2xl p-5 md:p-6 border border-secondary-200/60 flex flex-col justify-between">
                    <div>
                      <div className="text-accent-500 mb-2">
                        <i className="ri-double-quotes-l text-xl"></i>
                      </div>
                      <p className="text-foreground-700 text-xs md:text-sm leading-relaxed mb-4">
                        {item.quote}
                      </p>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                        <img
                          src={item.avatar}
                          alt={item.name}
                          className="w-full h-full object-cover"
                          title={item.name}
                        />
                      </div>
                      <div>
                        <p className="text-foreground-950 font-semibold text-xs">{item.name}</p>
                        <p className="text-foreground-400 text-xs">{item.role}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}